import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DropDown_Expression } from '@app/hcs-frontend';
import { DBDef_Expression, ExpressionOutput_Boolean, isUserPickableExpression } from '@app/hcs-shared';
import { ICONS, Preview } from '@app/styles';
import { ModuleFE_FloatingWindows, windowRect } from '@nu-art/floating-windows';
import { Button, ComponentSync, TS_Loader } from '@nu-art/thunderstorm-frontend';
import { _values, exists } from '@nu-art/ts-common';
import './Dialog_AssignDPVExpression.scss';
import { ModuleFE_DiseaseValue } from '../../../../../_entity.js';
import { ModuleFE_CollectionActions } from '@nu-art/thunderstorm-frontend/modules/ModuleFE_CollectionActions';
export class Dialog_AssignDPVExpression extends ComponentSync {
    static show = (props) => {
        const model = {
            key: 'assign-dpv-expression',
            className: 'preview-window dialog__assign-dpv-expression',
            rect: { ...windowRect.thirdScreen_Middle(), height: undefined },
            moveable: true,
            resizable: true,
            content: (cb) => _jsx(Dialog_AssignDPVExpression, { ...props, onClose: cb })
        };
        ModuleFE_FloatingWindows.window.add(model);
    };
    // ######################## Life Cycle ########################
    deriveStateFromProps(nextProps, state) {
        state.expressionId ??= nextProps.diseaseValue.expressionId;
        return state;
    }
    componentDidMount() {
        //Check if the expression is used by any other entity
        const expressionId = this.props.diseaseValue.expressionId;
        if (!expressionId)
            return this.setState({ otherDependencies: true });
        ModuleFE_CollectionActions.check.usage({ dbKey: DBDef_Expression.dbKey, itemIds: [expressionId] }).execute((response) => {
            if (!response.dependencies)
                return this.setState({ otherDependencies: false });
            const itemDependencies = response.dependencies.dependencyMap[expressionId];
            const results = _values(itemDependencies);
            this.setState({ otherDependencies: results.length > 1 || results[0].length > 1 });
        }, (err) => {
            this.logError(err);
        });
    }
    // ######################## Logic ########################
    expressionFilter = (exp) => {
        return exp.outputType === ExpressionOutput_Boolean
            && isUserPickableExpression(exp);
    };
    canSave = () => exists(this.state.expressionId) && this.state.expressionId !== this.props.diseaseValue.expressionId;
    save = async () => {
        if (!this.canSave())
            return;
        const dv = {
            ...this.props.diseaseValue,
            expressionId: this.state.expressionId,
        };
        try {
            const updated = await ModuleFE_DiseaseValue.v1.upsert(dv).executeSync();
            this.props.onSave(updated);
            this.props.onClose();
        }
        catch (err) {
            this.logError(err);
        }
    };
    // ######################## Render ########################
    render() {
        return _jsxs(Preview.Root, { children: [this.render_Header(), this.render_Main()] });
    }
    render_Header = () => {
        return _jsxs(Preview.Header, { children: [_jsx(Preview.HeaderTitle, { children: "Assign Disease Value Expression" }), _jsx(Preview.HeaderTail, { children: _jsx(ICONS.advisor_avn_close.component, { onClick: this.props.onClose }) })] });
    };
    render_Main = () => {
        return _jsx(Preview.Main, { children: _jsxs(Preview.MainColumn, { children: [_jsx(DropDown_Expression.selectable, { selected: this.state.expressionId, onSelected: exp => this.setState({ expressionId: exp._id }), limitItems: 50, queryFilter: this.expressionFilter }), this.render_DeleteExpressionMessage(), _jsx(Button, { variant: 'primary', onClick: this.save, disabled: !this.canSave(), children: "Save" })] }) });
    };
    render_DeleteExpressionMessage = () => {
        if (!exists(this.state.otherDependencies))
            return _jsx(TS_Loader, {});
        if (this.state.otherDependencies)
            return;
        return _jsx("div", { className: 'exp-dependencies-message', children: "The current expression doesn't have any other dependencies, re-assigning an expression will also delete the current one." });
    };
}
//# sourceMappingURL=Dialog_AssignDPVExpression.js.map